import BaseService from './BaseService';
import { camelizeKeys } from 'humps';

const objectType = 'adult-surveillance-mosquitoes';

class AdultSurveillanceMosquitoServices extends BaseService {

  static create(data) {
    return super.post(objectType, `adult_surveillance_mosquitoes`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    return super.patch(objectType, `adult_surveillance_mosquitoes/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`adult_surveillance_mosquitoes/${id}`)
      .then(() => Promise.resolve({id}))
      .catch((error) => Promise.reject(error.response.data));
  }

}

export default AdultSurveillanceMosquitoServices;